module.exports = __webpack_public_path__ + "static/media/story-8.7a777530.jpg";